//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';

import DateString from '@models/DateString';
import {
  IInstagramStoryGroup,
  IInstagramStoryGroupMetrics,
} from '@models/IInstagramMediaItem';

export enum InstagramStorySearchSortKey {
  CompletionRate = 'CompletionRate',
  Date = 'Date',
  EngagementRate = 'EngagementRate',
  // The UI should display "Link Visits" but keeping this key as "SwipeUps" to match the backend
  SwipeUps = 'SwipeUps',
  Reach = 'Reach',
  Revenue = 'Revenue',
  Shares = 'Shares',
  Views = 'Views',
}

export interface IInstagramStoryGroupAggregateStats {
  impressions: number;
  reach: number;
  engagementRate: number;
  completionRate: number;
  storyGroupMetricsByLocalDate: PojoMap<
    DateString,
    IInstagramStoryGroupMetrics
  >;
  views?: number;
  // This metric actually represents "visits" to the link but keeping the deprecated "swipeUps" naming to match backend
  swipeUps: number;
  revenue?: number;
}

export interface IInstagramStoryGroupAnalyticsData {
  storyGroups: IInstagramStoryGroup[];
  swipeUpLinkData: IInstagramStoryLinkData[];
  swipeUpLinkDataByLocalDate: Record<string, IInstagramStoryLinkData[]>;
  aggregateStats: IInstagramStoryGroupAggregateStats;
  aggregateComparisonStats: IInstagramStoryGroupAggregateStats;
}

export interface IInstagramStoryLinkData {
  scheduledTimestamp: Date;
  url: string;
  shortlink?: string;
  // This metric actually represents "visits" to the link but keeping the deprecated "swipeUps" naming to match backend
  swipeUps: number;
  revenue?: number;
  fileId?: string;
}
